import React from "react";

const mediaState: any = {};
export const MediaContext = React.createContext(mediaState);
